import { render } from "./ColumnUi.vue?vue&type=template&id=3b4e872d&scoped=true"
import script from "./ColumnUi.vue?vue&type=script&lang=js"
export * from "./ColumnUi.vue?vue&type=script&lang=js"

import "./ColumnUi.vue?vue&type=style&index=0&id=3b4e872d&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4e872d"]])

export default __exports__